import React from 'react';
import { ReactComponent as DownChevronSVG } from './downchevron.svg';

export default function DownChevronIcon({width = 24, height = 24, color = 'black'})
{
  return (
    <DownChevronSVG
      width={width}
      height={height}
      style={{color: color}}
    />
  );
}
